/**
 * Props
 *
 * isMobile => device type | Required | boolean
 */

import React from "react";
import PropTypes from "prop-types";

import InstructionTicketMobile from "./InstructionTicketMobile";
import InstructionTicketDesktop from "./InstructionTicketDesktop";

const InstructionTicket = (props) => {

	const {
		isMobile,
		...prop
	} = props;

	if (isMobile) {

		return <InstructionTicketMobile {...prop} />;

	}

	return <InstructionTicketDesktop {...prop} />;

};

InstructionTicket.propTypes = {
	isMobile: PropTypes.bool.isRequired,
};

export default InstructionTicket;
